import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OkCancelDialog} from '../../../common/dialogs/okCancelDialog';

/*
 * Props.
 */

export interface SchedulingLinkSettingsCloseConfirmProps {
  onConfirmClick: Handler;
  onCancelClick: Handler;
}

/*
 * Component.
 */

export const SchedulingLinkSettingsCloseConfirm: FC<SchedulingLinkSettingsCloseConfirmProps> = (props) => (
  <OkCancelDialog
    title={<Trans id="schedulinglink-settings-close-title">Unsaved changes</Trans>}
    okButtonLabel={<Trans id="schedulinglink-settings-close-button">Discard</Trans>}
    onOkClick={props.onConfirmClick}
    onRequestClose={props.onCancelClick}
  >
    <Trans id="schedulinglink-settings-close-message">Do you want to discard unsaved changes?</Trans>
  </OkCancelDialog>
);
